import { makeStyles } from '@mui/styles'

export const paidConsumerDesktopNavHeight = 118
export const paidConsumerMobileNavHeight = 60

export const useStyles = makeStyles(({ spacing, palette }) => ({
  // Main AppBar styles
  appBar: {
    backgroundColor: palette.common.white,
    color: palette.text.primary,
    boxShadow: 'none',
    position: 'sticky',
    top: 0,
    left: 0,
    right: 0,
    zIndex: 1200
  },
  toolbar: {
    padding: '0',
    minHeight: 64,
    width: '100%'
  }
}))
